import { INTERNAL_PAYOUTS_SUPPORTED_COUNTRIES } from '@reverbdotcom/commons/dist/supported_countries';

export function isReverbPaymentsOnly({
  shopCountryCode,
  paymentProfileCreatedAt,
}: { shopCountryCode: string; paymentProfileCreatedAt: string }) {
  return isInternalPayoutsOnly(shopCountryCode) || isMarketpayOnly(shopCountryCode, paymentProfileCreatedAt);
}

function isInternalPayoutsOnly(countryCode: string) {
  return INTERNAL_PAYOUTS_SUPPORTED_COUNTRIES.includes(countryCode);
}

function isMarketpayOnly(countryCode: string, paymentProfileCreatedAt: string) {
  const rpOnlyStartDate = '2020-05-19';

  return countryCode === 'GB' &&
    Date.parse(paymentProfileCreatedAt) > Date.parse(rpOnlyStartDate);
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/reverb_payments_only_policy.ts